module.exports = __webpack_public_path__ + "static/slide1-54a50574b711a56995060eabe2fcf235.png";